// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* My Tickets — scoped (no generic names like "logo") */
.agce-mtickets {
  width: 100%;
}

.agce-mtickets__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 20px;
  flex-wrap: wrap;
  margin-bottom: 20px;
}

.agce-mtickets__titles {
  min-width: 0;
}

.agce-mtickets__title {
  font-size: 40px;
  font-weight: 600;
  /* color: #0f172a; */
  letter-spacing: -0.02em;
  margin: 0 0 8px;
  line-height: 1.2;
}

.kyc_approval_s.agce-mtickets-wrap {
  padding: 15px 0px 32px 40px;
}

.agce-mtickets__sub {
  margin: 0;
  font-size: 15px;
  font-weight: 400;
  color: #94a3b8;
  line-height: 1.5;
  max-width: 560px;
}

.agce-mtickets__cta {
  padding: 10px 32px;
  font-size: 14px;
  font-weight: 500;
  color: #ffffff;
  background: #333741;
  border: none;
  border-radius: 50px;
  cursor: pointer;
  flex-shrink: 0;
  transition: background 0.15s ease, transform 0.1s ease;
}

body.light_theme .agce-mtickets__cta {
  background: #101828;
}

.agce-mtickets__cta:hover {
  opacity: 0.85;
}

.agce-mtickets__toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
  margin-bottom: 0px;
}

.agce-mtickets__tabs {
  display: flex;
  gap: 25px;
  /* border-bottom: 1px solid #e2e8f0; */
  flex: 1 1;
  min-width: 200px;
}

.agce-mtickets__tab {
  padding: 0px 2px 9px;
  font-size: 16px;
  font-weight: 500;
  color: #8E939C;
  background: none;
  border: none;
  border-bottom: 2px solid transparent;
  margin-bottom: -1px;
  cursor: pointer;
  border-radius: 8px 8px 0 0;
}

/* .agce-mtickets__tab:hover {
  color: #0f172a;
  background: #f8fafc;
} */

.agce-mtickets__tab--active {
  color: #ffffff;
  border-bottom-color: #d7d7d7;
}

body.light_theme .agce-mtickets__tab--active {
  color: #0f172a;
  border-bottom-color: #0f172a;
}

.agce-mtickets__search {
  display: flex;
  align-items: center;
  gap: 8px;
}

.agce-mtickets__search-wrap {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 5px 14px;
  border: 1px solid #e5e7eb12;
  border-radius: 10px;
  background: #ffffff14;
  min-width: 250px;
}

body.light_theme .agce-mtickets__search-wrap {
  border: 1px solid #E5E7EB;
  background: #fff;
}

.agce-mtickets__search-wrap i {
  font-size: 18px;
  color: #94a3b8;
}

.agce-mtickets__search-input {
  border: none;
  outline: none;
  background: none;
  font-size: 14px;
  flex: 1 1;
  min-width: 0;
  color: #f3f3f3;
}

body.light_theme .agce-mtickets__search-input {
  color: #0f172a;
}

.agce-mtickets__search-input::placeholder {
  color: #94a3b8;
}

.agce-mtickets__icon-btn {
  width: 32px;
  height: 32px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 0px;
  background: #fff;
  cursor: pointer;
}

.agce-mtickets__icon-btn:hover {
  background: #f8fafc;
  color: #0f172a;
}

.agce-mtickets__tablewrap {
  width: 100%;
}

.agce-mtickets__table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

.agce-mtickets__table thead th {
  text-align: left;
  font-size: 12px;
  font-weight: 500;
  color: #94a3b8;
  padding: 14px 15px;
  border-bottom: 1px solid #e8ecf11c;
}

body.light_theme .agce-mtickets__table thead th {
  border-bottom: 1px solid #e8ecf1;
}

.agce-mtickets__table thead th.agce-mtickets__th-action {
  text-align: right;
}

.agce-mtickets__table tbody tr {
  border-bottom: 1px solid #e8ecf11c;
}

body.light_theme .agce-mtickets__table tbody tr {
  border-bottom: 1px solid #eef2f7;
}

.agce-mtickets__table tbody tr:last-child {
  border-bottom: none;
}

.agce-mtickets__table tbody td {
  padding: 16px 20px;
  color: #e6e6e6;
  font-weight: 500;
  vertical-align: middle;
}

body.light_theme .agce-mtickets__table tbody td {
  color: #334155;
}

.agce-mtickets__td-ticket {
  font-weight: 500 !important;
  color: #f1f1f1 !important;
}

body.light_theme .agce-mtickets__td-ticket {
  color: #0f172a !important;
}

.agce-mtickets__td-desc {
  font-weight: 400;
  color: #475569;
}

.agce-mtickets__td-action {
  text-align: right;
}

.agce-mtickets__empty {
  text-align: center;
  color: #94a3b8;
  font-weight: 500;
  padding: 40px 20px !important;
}

.agce-mtickets__emptyBox {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  min-height: 220px;
}

.agce-mtickets__emptyText {
  font-size: 14px;
  color: #94a3b8;
  font-weight: 600;
}

.agce-mtickets__link {
  color: #d1aa67;
  font-weight: 500;
  text-decoration: none;
  cursor: pointer;
  background: none;
  border: none;
  padding: 0;
  font-size: inherit;
}

.agce-mtickets__link:hover {
  text-decoration: underline;
}

@media (max-width: 1440px) {

  .agce-mtickets__title {
    font-size: 36px;
  }

  .kyc_approval_s.agce-mtickets-wrap {
    padding: 15px 0px 32px 40px;
  }

}

@media (max-width: 1200px) {

  .agce-mtickets__title {
    font-size: 30px;
  }

  .kyc_approval_s.agce-mtickets-wrap {
    padding: 15px 0px 32px 10px;
  }

}


@media (max-width: 991.98px) {

  .agce-mtickets__title {
    font-size: 22px;
  }

  .kyc_approval_s.agce-mtickets-wrap {
    padding: 0px 0px 10px 0px;
  }

  .agce-mtickets__toolbar {
    flex-direction: column;
    align-items: stretch;
  }

  .agce-mtickets__tabs {
    overflow-x: auto;
    flex-wrap: nowrap;
    -webkit-overflow-scrolling: touch;
  }

  .agce-mtickets__search {
    width: 100%;
  }

  .agce-mtickets__search-wrap {
    flex: 1 1;
  }

  /* Mobile: table -> card list */
  .agce-mtickets__tablewrap {
    overflow: visible;
  }

  .agce-mtickets__table {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0 12px;
  }

  .agce-mtickets__table thead {
    display: none;
  }

  .agce-mtickets__table tbody,
  .agce-mtickets__table tr,
  .agce-mtickets__table td {
    display: block;
    width: 100%;
  }

  .agce-mtickets__table tbody tr {
    background: #ffffff0f;
    border: 1px solid #eef2f71f;
    border-radius: 14px;
    overflow: hidden;
    box-shadow: 0px 1px 8px #0000000a;
    margin-bottom: 20px;
  }

  body.light_theme .agce-mtickets__table tbody tr {
    background: #fff;
    border: 1px solid #eef2f7;
  }

  .agce-mtickets__table tbody td {
    padding: 12px 14px;
    border-top: 1px solid #f1f5f93b;
    text-align: left;
  }

  body.light_theme .agce-mtickets__table tbody td {
    border-top: 1px solid #f1f5f9;
  }

  .agce-mtickets__table tbody td:first-child {
    border-top: 0;
  }

  .agce-mtickets__table tbody td[data-label] {
    display: grid;
    grid-template-columns: minmax(120px, 44%) 1fr;
    align-items: start;
    column-gap: 14px;
  }

  .agce-mtickets__table tbody td[data-label]::before {
    content: attr(data-label);
    font-size: 12px;
    font-weight: 600;
    color: #94a3b8;
    grid-column: 1;
    padding-top: 2px;
  }

  .agce-mtickets__table tbody td[data-label]>* {
    grid-column: 2;
    text-align: right;
    justify-self: end;
    min-width: 0;
    overflow-wrap: anywhere;
    word-break: break-word;
  }

  .agce-mtickets__table tbody td[data-label="Description"]>* {
    text-align: left;
    justify-self: start;
  }

  .agce-mtickets__td-action {
    text-align: left;
  }

  .agce-mtickets__table tbody td[data-label="Action"]>* {
    justify-self: start;
    text-align: left;
  }
}

@media (max-width: 767px) {

  .kyc_approval_s.agce-mtickets-wrap {
    margin: 0px;
  }

  .agce-mtickets__cta {
    padding: 8px 32px;
    font-size: 13px;
  }

  .agce-mtickets__tabs {
    gap: 15px;
  }

  .agce-mtickets__head {
    margin-bottom: 10px;
  }

  .agce-mtickets__tab {
    font-size: 14px;
  }

}

/* ===========================================================
   Ensure react-hot-toast (App.js Toaster) stays above any modal
   incl. our ticket chat modal. Some pages create stacking
   contexts that hide toasts; force max z-index here.
   =========================================================== */
.agce-global-toaster,
body>div.agce-global-toaster {
  z-index: 2147483647 !important;
}

.agce-global-toaster>div,
.agce-global-toaster [role="status"] {
  z-index: 2147483647 !important;
}

/* When ticket chat modal is open, also allow toaster to overlay backdrop */
body.modal-open .agce-global-toaster {
  z-index: 2147483647 !important;
  pointer-events: auto;
}

/* ===========================================================
   Ticket Chat Modal — clean white modern style
   (scoped via .agce-tchat to avoid touching other modals)
   =========================================================== */
.agce-tchat.modal {
  z-index: 1055;
}

.agce-tchat.modal.show {
  z-index: 99999999999 !important;
}

.agce-tchat .agce-tchat__dialog {
  max-width: 760px;
}

.agce-tchat .agce-tchat__content {
  position: relative;
  background: #1e202661;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 20px;
  box-shadow: 0 28px 72px rgba(0, 0, 0, 0.55);
  padding: 36px 36px 30px;
  color: #f0f0f0;
  overflow: hidden;
}

body.light_theme .agce-tchat .agce-tchat__content {
  background: rgb(255 255 255 / 20%);
  border: 1px solid #e5e7eb;
  box-shadow: 0 20px 60px rgba(15, 23, 42, 0.24);
  color: #0f172a;
}

.agce-tchat .agce-tchat__close {
  position: absolute;
  top: 20px;
  right: 20px;
  width: 36px;
  height: 36px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  border-radius: 50%;
  color: #94a3b8;
  font-size: 22px;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
}

body.light_theme .agce-tchat .agce-tchat__close {
  color: #64748b;
}

.agce-tchat .agce-tchat__close:hover {
  background: rgba(255, 255, 255, 0.08);
  color: #ffffff;
}

body.light_theme .agce-tchat .agce-tchat__close:hover {
  background: #f1f5f9;
  color: #0f172a;
}

.agce-tchat .agce-tchat__head {
  padding-right: 44px;
  margin-bottom: 22px;
}

.agce-tchat .agce-tchat__title {
  margin: 0 0 8px;
  font-size: 24px;
  font-weight: 700;
  color: #ffffff;
  letter-spacing: -0.01em;
  line-height: 1.25;
  display: flex;
  align-items: center;
  gap: 10px;
}

body.light_theme .agce-tchat .agce-tchat__title {
  color: #0f172a;
}

.agce-tchat .agce-tchat__refresh {
  appearance: none;
  border: none;
  background: rgba(255, 255, 255, 0.06);
  color: #94a3b8;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
}

body.light_theme .agce-tchat .agce-tchat__refresh {
  background: #f1f5f9;
  color: #475569;
}

.agce-tchat .agce-tchat__refresh:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.12);
  color: #ffffff;
}

body.light_theme .agce-tchat .agce-tchat__refresh:hover:not(:disabled) {
  background: #e2e8f0;
  color: #0f172a;
}

.agce-tchat .agce-tchat__refresh:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.agce-tchat .agce-tchat__sub {
  margin: 0;
  font-size: 14px;
  color: #94a3b8;
  line-height: 1.5;
}

body.light_theme .agce-tchat .agce-tchat__sub {
  color: #64748b;
}

.agce-tchat .agce-tchat__tid {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: #f0f0f0;
  font-weight: 600;
  cursor: pointer;
  padding: 2px 8px;
  border-radius: 999px;
  transition: background 0.15s ease;
}

body.light_theme .agce-tchat .agce-tchat__tid {
  color: #0f172a;
}

.agce-tchat .agce-tchat__tid:hover {
  background: rgba(255, 255, 255, 0.08);
}

body.light_theme .agce-tchat .agce-tchat__tid:hover {
  background: #f1f5f9;
}

.agce-tchat .agce-tchat__tid i {
  font-size: 14px;
  color: #94a3b8;
}

body.light_theme .agce-tchat .agce-tchat__tid i {
  color: #64748b;
}

.agce-tchat .agce-tchat__body {
  max-height: 64vh;
  min-height: 320px;
  overflow-y: auto;
  padding-right: 6px;
  margin: 0 -6px 20px 0;
}

.agce-tchat .agce-tchat__body::-webkit-scrollbar {
  width: 6px;
}

.agce-tchat .agce-tchat__body::-webkit-scrollbar-thumb {
  background: #e2e8f0;
  border-radius: 999px;
}

.agce-tchat .agce-tchat__info {
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 16px;
  padding: 18px 20px;
  margin-bottom: 20px;
}

body.light_theme .agce-tchat .agce-tchat__info {
  background: #f8fafc;
  border: 1px solid #eef2f7;
}

.agce-tchat .agce-tchat__info-row {
  display: flex;
  gap: 10px;
  font-size: 14px;
  line-height: 1.5;
  margin-bottom: 8px;
  flex-wrap: wrap;
}

.agce-tchat .agce-tchat__info-row:last-of-type {
  margin-bottom: 0;
}

.agce-tchat .agce-tchat__info-label {
  color: #94a3b8;
  font-weight: 500;
  min-width: 110px;
}

.agce-tchat .agce-tchat__info-val {
  color: #f0f0f0;
  font-weight: 500;
  word-break: break-word;
}

body.light_theme .agce-tchat .agce-tchat__info-val {
  color: #0f172a;
}

.agce-tchat .agce-tchat__chips {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 10px;
}

.agce-tchat .agce-tchat__chip {
  display: inline-flex;
  align-items: center;
  padding: 5px 12px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.08);
  color: #e2e8f0;
  font-size: 12px;
  font-weight: 500;
  text-transform: capitalize;
  letter-spacing: 0.01em;
}

body.light_theme .agce-tchat .agce-tchat__chip {
  background: #eef2f7;
  color: #334155;
}

.agce-tchat .agce-tchat__chip--priority {
  background: rgba(245, 158, 11, 0.15);
  color: #fcd34d;
}

body.light_theme .agce-tchat .agce-tchat__chip--priority {
  background: #fef3c7;
  color: #92400e;
}

.agce-tchat .agce-tchat__chip--status {
  background: rgba(34, 197, 94, 0.15);
  color: #86efac;
}

body.light_theme .agce-tchat .agce-tchat__chip--status {
  background: #dcfce7;
  color: #166534;
}

.agce-tchat .agce-tchat__desc {
  margin: 14px 0 0;
  font-size: 14px;
  line-height: 1.6;
  color: #94a3b8;
  white-space: pre-wrap;
}

body.light_theme .agce-tchat .agce-tchat__desc {
  color: #475569;
}

.agce-tchat .agce-tchat__messages {
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 6px 0 0;
}

.agce-tchat .agce-tchat__empty {
  text-align: center;
  font-size: 13px;
  color: #94a3b8;
  padding: 18px 8px;
}

.agce-tchat .agce-tchat__msg {
  display: flex;
  align-items: flex-end;
  gap: 8px;
  max-width: 100%;
}

.agce-tchat .agce-tchat__msg--mine {
  flex-direction: row-reverse;
}

.agce-tchat .agce-tchat__avatar {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
  color: #e2e8f0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 600;
  flex-shrink: 0;
}

body.light_theme .agce-tchat .agce-tchat__avatar {
  background: #e2e8f0;
  color: #475569;
}

.agce-tchat .agce-tchat__avatar--mine {
  background: #f0f0f0;
  color: #1e2026;
}

body.light_theme .agce-tchat .agce-tchat__avatar--mine {
  background: #0f172a26;
  color: #000000;
}

.agce-tchat .agce-tchat__bubble {
  max-width: 78%;
  padding: 12px 16px;
  border-radius: 16px;
  font-size: 14px;
  line-height: 1.55;
  word-break: break-word;
  background: rgba(255, 255, 255, 0.06);
  color: #f0f0f0;
  border-top-left-radius: 4px;
}

body.light_theme .agce-tchat .agce-tchat__bubble {
  background: #f1f5f9;
  color: #0f172a;
}

.agce-tchat .agce-tchat__msg--mine .agce-tchat__bubble {
  background: #ffffff0f;
  color: #ffffff;
  border-top-left-radius: 16px;
  border-top-right-radius: 4px;
}

body.light_theme .agce-tchat .agce-tchat__msg--mine .agce-tchat__bubble {
  background: #0f172a14;
  color: #000000;
}

.agce-tchat .agce-tchat__bubble-text {
  white-space: pre-wrap;
}

.agce-tchat .agce-tchat__img-link {
  display: inline-block;
  margin-top: 6px;
  border-radius: 10px;
  overflow: hidden;
  line-height: 0;
  border: none;
  padding: 0;
  background: transparent;
  cursor: zoom-in;
}

.agce-tchat .agce-tchat__inline-img {
  display: block;
  max-width: 240px;
  max-height: 240px;
  width: auto;
  height: auto;
  border-radius: 10px;
  object-fit: cover;
  cursor: zoom-in;
  transition: transform 0.15s ease;
}

.agce-tchat .agce-tchat__inline-img:hover {
  transform: scale(1.02);
}

.agce-tchat .agce-tchat__bubble-time {
  margin-top: 4px;
  font-size: 10px;
  opacity: 0.65;
  text-align: right;
}

.agce-tchat .agce-tchat__msg--them .agce-tchat__bubble-time {
  text-align: left;
}

.agce-tchat .agce-tchat__foot {
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  padding-top: 20px;
}

body.light_theme .agce-tchat .agce-tchat__foot {
  border-top: 1px solid #eef2f7;
}

.agce-tchat .agce-tchat__input-wrap {
  display: flex;
  align-items: center;
  gap: 8px;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 999px;
  padding: 6px 6px 6px 8px;
  transition: border-color 0.15s ease, box-shadow 0.15s ease, background 0.15s ease;
}

body.light_theme .agce-tchat .agce-tchat__input-wrap {
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
}

.agce-tchat .agce-tchat__attach {
  flex: 0 0 auto;
  width: 38px;
  height: 38px;
  border-radius: 50%;
  border: none;
  background: transparent;
  color: #94a3b8;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
}

body.light_theme .agce-tchat .agce-tchat__attach {
  color: #475569;
}

.agce-tchat .agce-tchat__attach:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.08);
  color: #ffffff;
}

body.light_theme .agce-tchat .agce-tchat__attach:hover:not(:disabled) {
  background: #e2e8f0;
  color: #0f172a;
}

.agce-tchat .agce-tchat__attach:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.agce-tchat .agce-tchat__attach-preview {
  display: flex;
  align-items: center;
  gap: 12px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  padding: 8px 10px 8px 8px;
  margin-bottom: 12px;
}

.agce-tchat .agce-tchat__attach-thumb {
  width: 44px;
  height: 44px;
  border-radius: 10px;
  object-fit: cover;
  background: #e2e8f0;
  flex-shrink: 0;
  display: block;
}

.agce-tchat .agce-tchat__attach-thumb-btn {
  border: none;
  padding: 0;
  background: transparent;
  cursor: zoom-in;
  flex-shrink: 0;
  line-height: 0;
}

.agce-tchat .agce-tchat__attach-thumb--icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #64748b;
  font-size: 22px;
}

.agce-tchat .agce-tchat__attach-meta {
  flex: 1 1;
  min-width: 0;
}

.agce-tchat .agce-tchat__attach-name {
  font-size: 13px;
  font-weight: 500;
  color: #0f172a;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.agce-tchat .agce-tchat__attach-size {
  font-size: 11px;
  color: #94a3b8;
  margin-top: 2px;
}

.agce-tchat .agce-tchat__attach-remove {
  flex: 0 0 auto;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: none;
  background: transparent;
  color: #64748b;
  font-size: 16px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
}

.agce-tchat .agce-tchat__attach-remove:hover:not(:disabled) {
  background: #fee2e2;
  color: #b91c1c;
}

.agce-tchat .agce-tchat__attach-remove:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.agce-tchat .agce-tchat__input-wrap:focus-within {
  box-shadow: 0 0 0 3px rgba(15, 23, 42, 0.06);

}

.agce-tchat .agce-tchat__input {
  flex: 1 1;
  min-width: 0;
  border: none;
  outline: none;
  background: transparent;
  font-size: 15px;
  color: #f0f0f0;
  padding: 8px 0;
}

body.light_theme .agce-tchat .agce-tchat__input {
  color: #0f172a;
}

.agce-tchat .agce-tchat__input::placeholder {
  color: #94a3b8;
}

.agce-tchat .agce-tchat__input:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.agce-tchat .agce-tchat__send {
  flex: 0 0 auto;
  width: 42px;
  height: 42px;
  border-radius: 50%;
  border: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #f0f0f0;
  color: #1e2026;
  font-size: 18px;
  line-height: 1;
  cursor: pointer;
  transition: background 0.15s ease, opacity 0.15s ease, transform 0.1s ease;
}

body.light_theme .agce-tchat .agce-tchat__send {
  background: #475569;
  color: #ffffff;
}

.agce-tchat .agce-tchat__send:hover:not(:disabled) {
  background: #ffffff;
}

body.light_theme .agce-tchat .agce-tchat__send:hover:not(:disabled) {
  background: #334155;
}

.agce-tchat .agce-tchat__send:active:not(:disabled) {
  transform: scale(0.96);
}

.agce-tchat .agce-tchat__send:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.agce-tchat .agce-tchat__send i {
  display: inline-block;
  line-height: 1;
}

.agce-tchat .agce-tchat__spin {
  animation: agce-tchat-spin 0.9s linear infinite;
}

@keyframes agce-tchat-spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

@media (max-width: 767px) {
  .agce-tchat .agce-tchat__dialog {
    max-width: 100%;
  }
}

@media (max-width: 575px) {
  .agce-tchat .agce-tchat__content {
    padding: 24px 20px 20px;
    border-radius: 16px;
  }

  .agce-mtickets__tablewrap {
    overflow: auto;
  }

  .agce-tchat .agce-tchat__info-row {
    font-size: 12px;
  }

  .agce-tchat .agce-tchat__desc {
    font-size: 12px;
  }

  .agce-tchat .agce-tchat__title {
    font-size: 20px;
  }

  .agce-tchat .agce-tchat__bubble {
    max-width: 86%;
    font-size: 13px;
  }

  .agce-tchat .agce-tchat__input-wrap {
    padding: 5px 5px 5px 6px;
  }

  .agce-tchat .agce-tchat__send {
    width: 38px;
    height: 38px;
    font-size: 16px;
  }

  .agce-tchat .agce-tchat__attach {
    width: 34px;
    height: 34px;
    font-size: 16px;
  }

  .agce-tchat .agce-tchat__input {
    font-size: 14px;
  }
}

.agce-tchat__preview-backdrop {
  position: fixed;
  inset: 0;
  /* Above global \`.modal { z-index: 99999999999 !important; }\` in style.css */
  z-index: 100000000000 !important;
  background: rgba(8, 12, 20, 0.88);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  isolation: isolate;
}

.agce-tchat__preview-panel {
  position: relative;
  width: min(100%, 920px);
  max-height: calc(100vh - 48px);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
}

.agce-tchat__preview-close {
  position: absolute;
  top: -8px;
  right: -8px;
  width: 40px;
  height: 40px;
  border: none;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.12);
  color: #ffffff;
  font-size: 22px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.agce-tchat__preview-img {
  display: block;
  max-width: 100%;
  max-height: calc(100vh - 140px);
  width: auto;
  height: auto;
  object-fit: contain;
  border-radius: 12px;
  background: #111827;
}

.agce-tchat__preview-open {
  border: none;
  border-radius: 999px;
  padding: 10px 18px;
  background: #d1aa67;
  color: #101010;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/ui/Pages/MyTicketsPage/myTickets.css"],"names":[],"mappings":"AAAA,uDAAuD;AACvD;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,sDAAsD;AACxD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,sCAAsC;EACtC,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,oCAAoC;EACpC,mBAAmB;EACnB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;;;GAGG;;AAEH;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,2BAA2B;EAC3B,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,SAAO;EACP,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;EAEE;IACE,eAAe;EACjB;;EAEA;IACE,2BAA2B;EAC7B;;AAEF;;AAEA;;EAEE;IACE,eAAe;EACjB;;EAEA;IACE,2BAA2B;EAC7B;;AAEF;;;AAGA;;EAEE;IACE,eAAe;EACjB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,iCAAiC;EACnC;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,SAAO;EACT;;EAEA,+BAA+B;EAC/B;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,yBAAyB;IACzB,sBAAsB;EACxB;;EAEA;IACE,aAAa;EACf;;EAEA;;;IAGE,cAAc;IACd,WAAW;EACb;;EAEA;IACE,qBAAqB;IACrB,2BAA2B;IAC3B,mBAAmB;IACnB,gBAAgB;IAChB,iCAAiC;IACjC,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,+BAA+B;IAC/B,gBAAgB;EAClB;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,6CAA6C;IAC7C,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,iBAAiB;IACjB,iBAAiB;IACjB,YAAY;IACZ,uBAAuB;IACvB,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;EAClB;AACF;;AAEA;;EAEE;IACE,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;AAEF;;AAEA;;;;gEAIgE;AAChE;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA,2EAA2E;AAC3E;EACE,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;;;gEAGgE;AAChE;EACE,aAAa;AACf;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,2CAA2C;EAC3C,mBAAmB;EACnB,2CAA2C;EAC3C,uBAAuB;EACvB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;EACzB,8CAA8C;EAC9C,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,eAAe;EACf,mDAAmD;AACrD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,qCAAqC;EACrC,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,mDAAmD;AACrD;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,iCAAiC;AACnC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,qCAAqC;EACrC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,qCAAqC;EACrC,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,UAAU;EACV,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,+CAA+C;EAC/C,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,qCAAqC;EACrC,2CAA2C;EAC3C,oBAAoB;EACpB,wBAAwB;EACxB,iFAAiF;AACnF;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,mDAAmD;AACrD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,mDAAmD;AACrD;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,4CAA4C;;AAE9C;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;EACf,0EAA0E;AAC5E;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,4EAA4E;EAC5E,gCAAgC;EAChC,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,8BAA8B;EAC9B,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,qCAAqC;EACrC,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,+BAA+B;EAC/B,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB","sourcesContent":["/* My Tickets — scoped (no generic names like \"logo\") */\n.agce-mtickets {\n  width: 100%;\n}\n\n.agce-mtickets__head {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 20px;\n  flex-wrap: wrap;\n  margin-bottom: 20px;\n}\n\n.agce-mtickets__titles {\n  min-width: 0;\n}\n\n.agce-mtickets__title {\n  font-size: 40px;\n  font-weight: 600;\n  /* color: #0f172a; */\n  letter-spacing: -0.02em;\n  margin: 0 0 8px;\n  line-height: 1.2;\n}\n\n.kyc_approval_s.agce-mtickets-wrap {\n  padding: 15px 0px 32px 40px;\n}\n\n.agce-mtickets__sub {\n  margin: 0;\n  font-size: 15px;\n  font-weight: 400;\n  color: #94a3b8;\n  line-height: 1.5;\n  max-width: 560px;\n}\n\n.agce-mtickets__cta {\n  padding: 10px 32px;\n  font-size: 14px;\n  font-weight: 500;\n  color: #ffffff;\n  background: #333741;\n  border: none;\n  border-radius: 50px;\n  cursor: pointer;\n  flex-shrink: 0;\n  transition: background 0.15s ease, transform 0.1s ease;\n}\n\nbody.light_theme .agce-mtickets__cta {\n  background: #101828;\n}\n\n.agce-mtickets__cta:hover {\n  opacity: 0.85;\n}\n\n.agce-mtickets__toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  flex-wrap: wrap;\n  margin-bottom: 0px;\n}\n\n.agce-mtickets__tabs {\n  display: flex;\n  gap: 25px;\n  /* border-bottom: 1px solid #e2e8f0; */\n  flex: 1 1;\n  min-width: 200px;\n}\n\n.agce-mtickets__tab {\n  padding: 0px 2px 9px;\n  font-size: 16px;\n  font-weight: 500;\n  color: #8E939C;\n  background: none;\n  border: none;\n  border-bottom: 2px solid transparent;\n  margin-bottom: -1px;\n  cursor: pointer;\n  border-radius: 8px 8px 0 0;\n}\n\n/* .agce-mtickets__tab:hover {\n  color: #0f172a;\n  background: #f8fafc;\n} */\n\n.agce-mtickets__tab--active {\n  color: #ffffff;\n  border-bottom-color: #d7d7d7;\n}\n\nbody.light_theme .agce-mtickets__tab--active {\n  color: #0f172a;\n  border-bottom-color: #0f172a;\n}\n\n.agce-mtickets__search {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.agce-mtickets__search-wrap {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 5px 14px;\n  border: 1px solid #e5e7eb12;\n  border-radius: 10px;\n  background: #ffffff14;\n  min-width: 250px;\n}\n\nbody.light_theme .agce-mtickets__search-wrap {\n  border: 1px solid #E5E7EB;\n  background: #fff;\n}\n\n.agce-mtickets__search-wrap i {\n  font-size: 18px;\n  color: #94a3b8;\n}\n\n.agce-mtickets__search-input {\n  border: none;\n  outline: none;\n  background: none;\n  font-size: 14px;\n  flex: 1;\n  min-width: 0;\n  color: #f3f3f3;\n}\n\nbody.light_theme .agce-mtickets__search-input {\n  color: #0f172a;\n}\n\n.agce-mtickets__search-input::placeholder {\n  color: #94a3b8;\n}\n\n.agce-mtickets__icon-btn {\n  width: 32px;\n  height: 32px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: none;\n  border-radius: 0px;\n  background: #fff;\n  cursor: pointer;\n}\n\n.agce-mtickets__icon-btn:hover {\n  background: #f8fafc;\n  color: #0f172a;\n}\n\n.agce-mtickets__tablewrap {\n  width: 100%;\n}\n\n.agce-mtickets__table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 14px;\n}\n\n.agce-mtickets__table thead th {\n  text-align: left;\n  font-size: 12px;\n  font-weight: 500;\n  color: #94a3b8;\n  padding: 14px 15px;\n  border-bottom: 1px solid #e8ecf11c;\n}\n\nbody.light_theme .agce-mtickets__table thead th {\n  border-bottom: 1px solid #e8ecf1;\n}\n\n.agce-mtickets__table thead th.agce-mtickets__th-action {\n  text-align: right;\n}\n\n.agce-mtickets__table tbody tr {\n  border-bottom: 1px solid #e8ecf11c;\n}\n\nbody.light_theme .agce-mtickets__table tbody tr {\n  border-bottom: 1px solid #eef2f7;\n}\n\n.agce-mtickets__table tbody tr:last-child {\n  border-bottom: none;\n}\n\n.agce-mtickets__table tbody td {\n  padding: 16px 20px;\n  color: #e6e6e6;\n  font-weight: 500;\n  vertical-align: middle;\n}\n\nbody.light_theme .agce-mtickets__table tbody td {\n  color: #334155;\n}\n\n.agce-mtickets__td-ticket {\n  font-weight: 500 !important;\n  color: #f1f1f1 !important;\n}\n\nbody.light_theme .agce-mtickets__td-ticket {\n  color: #0f172a !important;\n}\n\n.agce-mtickets__td-desc {\n  font-weight: 400;\n  color: #475569;\n}\n\n.agce-mtickets__td-action {\n  text-align: right;\n}\n\n.agce-mtickets__empty {\n  text-align: center;\n  color: #94a3b8;\n  font-weight: 500;\n  padding: 40px 20px !important;\n}\n\n.agce-mtickets__emptyBox {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  min-height: 220px;\n}\n\n.agce-mtickets__emptyText {\n  font-size: 14px;\n  color: #94a3b8;\n  font-weight: 600;\n}\n\n.agce-mtickets__link {\n  color: #d1aa67;\n  font-weight: 500;\n  text-decoration: none;\n  cursor: pointer;\n  background: none;\n  border: none;\n  padding: 0;\n  font-size: inherit;\n}\n\n.agce-mtickets__link:hover {\n  text-decoration: underline;\n}\n\n@media (max-width: 1440px) {\n\n  .agce-mtickets__title {\n    font-size: 36px;\n  }\n\n  .kyc_approval_s.agce-mtickets-wrap {\n    padding: 15px 0px 32px 40px;\n  }\n\n}\n\n@media (max-width: 1200px) {\n\n  .agce-mtickets__title {\n    font-size: 30px;\n  }\n\n  .kyc_approval_s.agce-mtickets-wrap {\n    padding: 15px 0px 32px 10px;\n  }\n\n}\n\n\n@media (max-width: 991.98px) {\n\n  .agce-mtickets__title {\n    font-size: 22px;\n  }\n\n  .kyc_approval_s.agce-mtickets-wrap {\n    padding: 0px 0px 10px 0px;\n  }\n\n  .agce-mtickets__toolbar {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .agce-mtickets__tabs {\n    overflow-x: auto;\n    flex-wrap: nowrap;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .agce-mtickets__search {\n    width: 100%;\n  }\n\n  .agce-mtickets__search-wrap {\n    flex: 1;\n  }\n\n  /* Mobile: table -> card list */\n  .agce-mtickets__tablewrap {\n    overflow: visible;\n  }\n\n  .agce-mtickets__table {\n    width: 100%;\n    border-collapse: separate;\n    border-spacing: 0 12px;\n  }\n\n  .agce-mtickets__table thead {\n    display: none;\n  }\n\n  .agce-mtickets__table tbody,\n  .agce-mtickets__table tr,\n  .agce-mtickets__table td {\n    display: block;\n    width: 100%;\n  }\n\n  .agce-mtickets__table tbody tr {\n    background: #ffffff0f;\n    border: 1px solid #eef2f71f;\n    border-radius: 14px;\n    overflow: hidden;\n    box-shadow: 0px 1px 8px #0000000a;\n    margin-bottom: 20px;\n  }\n\n  body.light_theme .agce-mtickets__table tbody tr {\n    background: #fff;\n    border: 1px solid #eef2f7;\n  }\n\n  .agce-mtickets__table tbody td {\n    padding: 12px 14px;\n    border-top: 1px solid #f1f5f93b;\n    text-align: left;\n  }\n\n  body.light_theme .agce-mtickets__table tbody td {\n    border-top: 1px solid #f1f5f9;\n  }\n\n  .agce-mtickets__table tbody td:first-child {\n    border-top: 0;\n  }\n\n  .agce-mtickets__table tbody td[data-label] {\n    display: grid;\n    grid-template-columns: minmax(120px, 44%) 1fr;\n    align-items: start;\n    column-gap: 14px;\n  }\n\n  .agce-mtickets__table tbody td[data-label]::before {\n    content: attr(data-label);\n    font-size: 12px;\n    font-weight: 600;\n    color: #94a3b8;\n    grid-column: 1;\n    padding-top: 2px;\n  }\n\n  .agce-mtickets__table tbody td[data-label]>* {\n    grid-column: 2;\n    text-align: right;\n    justify-self: end;\n    min-width: 0;\n    overflow-wrap: anywhere;\n    word-break: break-word;\n  }\n\n  .agce-mtickets__table tbody td[data-label=\"Description\"]>* {\n    text-align: left;\n    justify-self: start;\n  }\n\n  .agce-mtickets__td-action {\n    text-align: left;\n  }\n\n  .agce-mtickets__table tbody td[data-label=\"Action\"]>* {\n    justify-self: start;\n    text-align: left;\n  }\n}\n\n@media (max-width: 767px) {\n\n  .kyc_approval_s.agce-mtickets-wrap {\n    margin: 0px;\n  }\n\n  .agce-mtickets__cta {\n    padding: 8px 32px;\n    font-size: 13px;\n  }\n\n  .agce-mtickets__tabs {\n    gap: 15px;\n  }\n\n  .agce-mtickets__head {\n    margin-bottom: 10px;\n  }\n\n  .agce-mtickets__tab {\n    font-size: 14px;\n  }\n\n}\n\n/* ===========================================================\n   Ensure react-hot-toast (App.js Toaster) stays above any modal\n   incl. our ticket chat modal. Some pages create stacking\n   contexts that hide toasts; force max z-index here.\n   =========================================================== */\n.agce-global-toaster,\nbody>div.agce-global-toaster {\n  z-index: 2147483647 !important;\n}\n\n.agce-global-toaster>div,\n.agce-global-toaster [role=\"status\"] {\n  z-index: 2147483647 !important;\n}\n\n/* When ticket chat modal is open, also allow toaster to overlay backdrop */\nbody.modal-open .agce-global-toaster {\n  z-index: 2147483647 !important;\n  pointer-events: auto;\n}\n\n/* ===========================================================\n   Ticket Chat Modal — clean white modern style\n   (scoped via .agce-tchat to avoid touching other modals)\n   =========================================================== */\n.agce-tchat.modal {\n  z-index: 1055;\n}\n\n.agce-tchat.modal.show {\n  z-index: 99999999999 !important;\n}\n\n.agce-tchat .agce-tchat__dialog {\n  max-width: 760px;\n}\n\n.agce-tchat .agce-tchat__content {\n  position: relative;\n  background: #1e202661;\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  border-radius: 20px;\n  box-shadow: 0 28px 72px rgba(0, 0, 0, 0.55);\n  padding: 36px 36px 30px;\n  color: #f0f0f0;\n  overflow: hidden;\n}\n\nbody.light_theme .agce-tchat .agce-tchat__content {\n  background: rgb(255 255 255 / 20%);\n  border: 1px solid #e5e7eb;\n  box-shadow: 0 20px 60px rgba(15, 23, 42, 0.24);\n  color: #0f172a;\n}\n\n.agce-tchat .agce-tchat__close {\n  position: absolute;\n  top: 20px;\n  right: 20px;\n  width: 36px;\n  height: 36px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: transparent;\n  border: none;\n  border-radius: 50%;\n  color: #94a3b8;\n  font-size: 22px;\n  cursor: pointer;\n  transition: background 0.15s ease, color 0.15s ease;\n}\n\nbody.light_theme .agce-tchat .agce-tchat__close {\n  color: #64748b;\n}\n\n.agce-tchat .agce-tchat__close:hover {\n  background: rgba(255, 255, 255, 0.08);\n  color: #ffffff;\n}\n\nbody.light_theme .agce-tchat .agce-tchat__close:hover {\n  background: #f1f5f9;\n  color: #0f172a;\n}\n\n.agce-tchat .agce-tchat__head {\n  padding-right: 44px;\n  margin-bottom: 22px;\n}\n\n.agce-tchat .agce-tchat__title {\n  margin: 0 0 8px;\n  font-size: 24px;\n  font-weight: 700;\n  color: #ffffff;\n  letter-spacing: -0.01em;\n  line-height: 1.25;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\nbody.light_theme .agce-tchat .agce-tchat__title {\n  color: #0f172a;\n}\n\n.agce-tchat .agce-tchat__refresh {\n  appearance: none;\n  border: none;\n  background: rgba(255, 255, 255, 0.06);\n  color: #94a3b8;\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 16px;\n  cursor: pointer;\n  transition: background 0.15s ease, color 0.15s ease;\n}\n\nbody.light_theme .agce-tchat .agce-tchat__refresh {\n  background: #f1f5f9;\n  color: #475569;\n}\n\n.agce-tchat .agce-tchat__refresh:hover:not(:disabled) {\n  background: rgba(255, 255, 255, 0.12);\n  color: #ffffff;\n}\n\nbody.light_theme .agce-tchat .agce-tchat__refresh:hover:not(:disabled) {\n  background: #e2e8f0;\n  color: #0f172a;\n}\n\n.agce-tchat .agce-tchat__refresh:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.agce-tchat .agce-tchat__sub {\n  margin: 0;\n  font-size: 14px;\n  color: #94a3b8;\n  line-height: 1.5;\n}\n\nbody.light_theme .agce-tchat .agce-tchat__sub {\n  color: #64748b;\n}\n\n.agce-tchat .agce-tchat__tid {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  color: #f0f0f0;\n  font-weight: 600;\n  cursor: pointer;\n  padding: 2px 8px;\n  border-radius: 999px;\n  transition: background 0.15s ease;\n}\n\nbody.light_theme .agce-tchat .agce-tchat__tid {\n  color: #0f172a;\n}\n\n.agce-tchat .agce-tchat__tid:hover {\n  background: rgba(255, 255, 255, 0.08);\n}\n\nbody.light_theme .agce-tchat .agce-tchat__tid:hover {\n  background: #f1f5f9;\n}\n\n.agce-tchat .agce-tchat__tid i {\n  font-size: 14px;\n  color: #94a3b8;\n}\n\nbody.light_theme .agce-tchat .agce-tchat__tid i {\n  color: #64748b;\n}\n\n.agce-tchat .agce-tchat__body {\n  max-height: 64vh;\n  min-height: 320px;\n  overflow-y: auto;\n  padding-right: 6px;\n  margin: 0 -6px 20px 0;\n}\n\n.agce-tchat .agce-tchat__body::-webkit-scrollbar {\n  width: 6px;\n}\n\n.agce-tchat .agce-tchat__body::-webkit-scrollbar-thumb {\n  background: #e2e8f0;\n  border-radius: 999px;\n}\n\n.agce-tchat .agce-tchat__info {\n  background: rgba(255, 255, 255, 0.04);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 16px;\n  padding: 18px 20px;\n  margin-bottom: 20px;\n}\n\nbody.light_theme .agce-tchat .agce-tchat__info {\n  background: #f8fafc;\n  border: 1px solid #eef2f7;\n}\n\n.agce-tchat .agce-tchat__info-row {\n  display: flex;\n  gap: 10px;\n  font-size: 14px;\n  line-height: 1.5;\n  margin-bottom: 8px;\n  flex-wrap: wrap;\n}\n\n.agce-tchat .agce-tchat__info-row:last-of-type {\n  margin-bottom: 0;\n}\n\n.agce-tchat .agce-tchat__info-label {\n  color: #94a3b8;\n  font-weight: 500;\n  min-width: 110px;\n}\n\n.agce-tchat .agce-tchat__info-val {\n  color: #f0f0f0;\n  font-weight: 500;\n  word-break: break-word;\n}\n\nbody.light_theme .agce-tchat .agce-tchat__info-val {\n  color: #0f172a;\n}\n\n.agce-tchat .agce-tchat__chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin-top: 10px;\n}\n\n.agce-tchat .agce-tchat__chip {\n  display: inline-flex;\n  align-items: center;\n  padding: 5px 12px;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.08);\n  color: #e2e8f0;\n  font-size: 12px;\n  font-weight: 500;\n  text-transform: capitalize;\n  letter-spacing: 0.01em;\n}\n\nbody.light_theme .agce-tchat .agce-tchat__chip {\n  background: #eef2f7;\n  color: #334155;\n}\n\n.agce-tchat .agce-tchat__chip--priority {\n  background: rgba(245, 158, 11, 0.15);\n  color: #fcd34d;\n}\n\nbody.light_theme .agce-tchat .agce-tchat__chip--priority {\n  background: #fef3c7;\n  color: #92400e;\n}\n\n.agce-tchat .agce-tchat__chip--status {\n  background: rgba(34, 197, 94, 0.15);\n  color: #86efac;\n}\n\nbody.light_theme .agce-tchat .agce-tchat__chip--status {\n  background: #dcfce7;\n  color: #166534;\n}\n\n.agce-tchat .agce-tchat__desc {\n  margin: 14px 0 0;\n  font-size: 14px;\n  line-height: 1.6;\n  color: #94a3b8;\n  white-space: pre-wrap;\n}\n\nbody.light_theme .agce-tchat .agce-tchat__desc {\n  color: #475569;\n}\n\n.agce-tchat .agce-tchat__messages {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  padding: 6px 0 0;\n}\n\n.agce-tchat .agce-tchat__empty {\n  text-align: center;\n  font-size: 13px;\n  color: #94a3b8;\n  padding: 18px 8px;\n}\n\n.agce-tchat .agce-tchat__msg {\n  display: flex;\n  align-items: flex-end;\n  gap: 8px;\n  max-width: 100%;\n}\n\n.agce-tchat .agce-tchat__msg--mine {\n  flex-direction: row-reverse;\n}\n\n.agce-tchat .agce-tchat__avatar {\n  width: 34px;\n  height: 34px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.1);\n  color: #e2e8f0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 13px;\n  font-weight: 600;\n  flex-shrink: 0;\n}\n\nbody.light_theme .agce-tchat .agce-tchat__avatar {\n  background: #e2e8f0;\n  color: #475569;\n}\n\n.agce-tchat .agce-tchat__avatar--mine {\n  background: #f0f0f0;\n  color: #1e2026;\n}\n\nbody.light_theme .agce-tchat .agce-tchat__avatar--mine {\n  background: #0f172a26;\n  color: #000000;\n}\n\n.agce-tchat .agce-tchat__bubble {\n  max-width: 78%;\n  padding: 12px 16px;\n  border-radius: 16px;\n  font-size: 14px;\n  line-height: 1.55;\n  word-break: break-word;\n  background: rgba(255, 255, 255, 0.06);\n  color: #f0f0f0;\n  border-top-left-radius: 4px;\n}\n\nbody.light_theme .agce-tchat .agce-tchat__bubble {\n  background: #f1f5f9;\n  color: #0f172a;\n}\n\n.agce-tchat .agce-tchat__msg--mine .agce-tchat__bubble {\n  background: #ffffff0f;\n  color: #ffffff;\n  border-top-left-radius: 16px;\n  border-top-right-radius: 4px;\n}\n\nbody.light_theme .agce-tchat .agce-tchat__msg--mine .agce-tchat__bubble {\n  background: #0f172a14;\n  color: #000000;\n}\n\n.agce-tchat .agce-tchat__bubble-text {\n  white-space: pre-wrap;\n}\n\n.agce-tchat .agce-tchat__img-link {\n  display: inline-block;\n  margin-top: 6px;\n  border-radius: 10px;\n  overflow: hidden;\n  line-height: 0;\n  border: none;\n  padding: 0;\n  background: transparent;\n  cursor: zoom-in;\n}\n\n.agce-tchat .agce-tchat__inline-img {\n  display: block;\n  max-width: 240px;\n  max-height: 240px;\n  width: auto;\n  height: auto;\n  border-radius: 10px;\n  object-fit: cover;\n  cursor: zoom-in;\n  transition: transform 0.15s ease;\n}\n\n.agce-tchat .agce-tchat__inline-img:hover {\n  transform: scale(1.02);\n}\n\n.agce-tchat .agce-tchat__bubble-time {\n  margin-top: 4px;\n  font-size: 10px;\n  opacity: 0.65;\n  text-align: right;\n}\n\n.agce-tchat .agce-tchat__msg--them .agce-tchat__bubble-time {\n  text-align: left;\n}\n\n.agce-tchat .agce-tchat__foot {\n  border-top: 1px solid rgba(255, 255, 255, 0.08);\n  padding-top: 20px;\n}\n\nbody.light_theme .agce-tchat .agce-tchat__foot {\n  border-top: 1px solid #eef2f7;\n}\n\n.agce-tchat .agce-tchat__input-wrap {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background: rgba(255, 255, 255, 0.04);\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  border-radius: 999px;\n  padding: 6px 6px 6px 8px;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease, background 0.15s ease;\n}\n\nbody.light_theme .agce-tchat .agce-tchat__input-wrap {\n  background: #f1f5f9;\n  border: 1px solid #e2e8f0;\n}\n\n.agce-tchat .agce-tchat__attach {\n  flex: 0 0 auto;\n  width: 38px;\n  height: 38px;\n  border-radius: 50%;\n  border: none;\n  background: transparent;\n  color: #94a3b8;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 18px;\n  cursor: pointer;\n  transition: background 0.15s ease, color 0.15s ease;\n}\n\nbody.light_theme .agce-tchat .agce-tchat__attach {\n  color: #475569;\n}\n\n.agce-tchat .agce-tchat__attach:hover:not(:disabled) {\n  background: rgba(255, 255, 255, 0.08);\n  color: #ffffff;\n}\n\nbody.light_theme .agce-tchat .agce-tchat__attach:hover:not(:disabled) {\n  background: #e2e8f0;\n  color: #0f172a;\n}\n\n.agce-tchat .agce-tchat__attach:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.agce-tchat .agce-tchat__attach-preview {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 14px;\n  padding: 8px 10px 8px 8px;\n  margin-bottom: 12px;\n}\n\n.agce-tchat .agce-tchat__attach-thumb {\n  width: 44px;\n  height: 44px;\n  border-radius: 10px;\n  object-fit: cover;\n  background: #e2e8f0;\n  flex-shrink: 0;\n  display: block;\n}\n\n.agce-tchat .agce-tchat__attach-thumb-btn {\n  border: none;\n  padding: 0;\n  background: transparent;\n  cursor: zoom-in;\n  flex-shrink: 0;\n  line-height: 0;\n}\n\n.agce-tchat .agce-tchat__attach-thumb--icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: #64748b;\n  font-size: 22px;\n}\n\n.agce-tchat .agce-tchat__attach-meta {\n  flex: 1;\n  min-width: 0;\n}\n\n.agce-tchat .agce-tchat__attach-name {\n  font-size: 13px;\n  font-weight: 500;\n  color: #0f172a;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.agce-tchat .agce-tchat__attach-size {\n  font-size: 11px;\n  color: #94a3b8;\n  margin-top: 2px;\n}\n\n.agce-tchat .agce-tchat__attach-remove {\n  flex: 0 0 auto;\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  border: none;\n  background: transparent;\n  color: #64748b;\n  font-size: 16px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: background 0.15s ease, color 0.15s ease;\n}\n\n.agce-tchat .agce-tchat__attach-remove:hover:not(:disabled) {\n  background: #fee2e2;\n  color: #b91c1c;\n}\n\n.agce-tchat .agce-tchat__attach-remove:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.agce-tchat .agce-tchat__input-wrap:focus-within {\n  box-shadow: 0 0 0 3px rgba(15, 23, 42, 0.06);\n\n}\n\n.agce-tchat .agce-tchat__input {\n  flex: 1;\n  min-width: 0;\n  border: none;\n  outline: none;\n  background: transparent;\n  font-size: 15px;\n  color: #f0f0f0;\n  padding: 8px 0;\n}\n\nbody.light_theme .agce-tchat .agce-tchat__input {\n  color: #0f172a;\n}\n\n.agce-tchat .agce-tchat__input::placeholder {\n  color: #94a3b8;\n}\n\n.agce-tchat .agce-tchat__input:disabled {\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n.agce-tchat .agce-tchat__send {\n  flex: 0 0 auto;\n  width: 42px;\n  height: 42px;\n  border-radius: 50%;\n  border: none;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: #f0f0f0;\n  color: #1e2026;\n  font-size: 18px;\n  line-height: 1;\n  cursor: pointer;\n  transition: background 0.15s ease, opacity 0.15s ease, transform 0.1s ease;\n}\n\nbody.light_theme .agce-tchat .agce-tchat__send {\n  background: #475569;\n  color: #ffffff;\n}\n\n.agce-tchat .agce-tchat__send:hover:not(:disabled) {\n  background: #ffffff;\n}\n\nbody.light_theme .agce-tchat .agce-tchat__send:hover:not(:disabled) {\n  background: #334155;\n}\n\n.agce-tchat .agce-tchat__send:active:not(:disabled) {\n  transform: scale(0.96);\n}\n\n.agce-tchat .agce-tchat__send:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.agce-tchat .agce-tchat__send i {\n  display: inline-block;\n  line-height: 1;\n}\n\n.agce-tchat .agce-tchat__spin {\n  animation: agce-tchat-spin 0.9s linear infinite;\n}\n\n@keyframes agce-tchat-spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n@media (max-width: 767px) {\n  .agce-tchat .agce-tchat__dialog {\n    max-width: 100%;\n  }\n}\n\n@media (max-width: 575px) {\n  .agce-tchat .agce-tchat__content {\n    padding: 24px 20px 20px;\n    border-radius: 16px;\n  }\n\n  .agce-mtickets__tablewrap {\n    overflow: auto;\n  }\n\n  .agce-tchat .agce-tchat__info-row {\n    font-size: 12px;\n  }\n\n  .agce-tchat .agce-tchat__desc {\n    font-size: 12px;\n  }\n\n  .agce-tchat .agce-tchat__title {\n    font-size: 20px;\n  }\n\n  .agce-tchat .agce-tchat__bubble {\n    max-width: 86%;\n    font-size: 13px;\n  }\n\n  .agce-tchat .agce-tchat__input-wrap {\n    padding: 5px 5px 5px 6px;\n  }\n\n  .agce-tchat .agce-tchat__send {\n    width: 38px;\n    height: 38px;\n    font-size: 16px;\n  }\n\n  .agce-tchat .agce-tchat__attach {\n    width: 34px;\n    height: 34px;\n    font-size: 16px;\n  }\n\n  .agce-tchat .agce-tchat__input {\n    font-size: 14px;\n  }\n}\n\n.agce-tchat__preview-backdrop {\n  position: fixed;\n  inset: 0;\n  /* Above global `.modal { z-index: 99999999999 !important; }` in style.css */\n  z-index: 100000000000 !important;\n  background: rgba(8, 12, 20, 0.88);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n  isolation: isolate;\n}\n\n.agce-tchat__preview-panel {\n  position: relative;\n  width: min(100%, 920px);\n  max-height: calc(100vh - 48px);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 14px;\n}\n\n.agce-tchat__preview-close {\n  position: absolute;\n  top: -8px;\n  right: -8px;\n  width: 40px;\n  height: 40px;\n  border: none;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.12);\n  color: #ffffff;\n  font-size: 22px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n}\n\n.agce-tchat__preview-img {\n  display: block;\n  max-width: 100%;\n  max-height: calc(100vh - 140px);\n  width: auto;\n  height: auto;\n  object-fit: contain;\n  border-radius: 12px;\n  background: #111827;\n}\n\n.agce-tchat__preview-open {\n  border: none;\n  border-radius: 999px;\n  padding: 10px 18px;\n  background: #d1aa67;\n  color: #101010;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
